import React from "react";
import _ from "lodash";
import cx from "classnames";
import s from "./pin.scss";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";

const propTypes = {
  length: PropTypes.number,
  onChange: PropTypes.func
};

const DefaultProps = {};

class Pin extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.reset = this.reset.bind(this);
    this.getValue = this.getValue.bind(this);

    this.state = {
      value: ""
    };
  }

  componentDidMount() {
    this.input.focus();
  }

  reset() {
    this.setState({ value: "" });
  }

  getValue() {
    return this.state.value.replace(" ", "");
  }

  handleChange(event) {
    this.setState({
      value: event.target.value
    });
  }

  render() {
    const { className, label, errors } = this.props;

    return (
      <div className={cx(className, s.inputContainer, { [s.withErrors]: errors })}>
        {label && <label className={s.label}>{label}</label>}
        <div className={s.pin}>
          <InputMask
            mask="999 999"
            onChange={this.handleChange}
            maskChar={null}
            value={this.state.value}
            inputRef={el => (this.input = el)}
          />
        </div>

        <div className={s.resetLink} onClick={this.reset}>
          {this.state.value && "Reset"}
        </div>
      </div>
    );
  }
}

//// Pin.propTypes = propTypes;
Pin.defaultProps = DefaultProps;

export default Pin;
